module.exports = __webpack_public_path__ + "img/ag.29f936bd.svg";